import app from './app';
import { REPORT_SERVICE_URL } from './../../libs/constants';
import { saveAs } from 'file-saver';

//POST
const getBusinessReports = (userId, requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const headerConfig = {
            headers: {
                "DRS-Fetch-Type": "getBusinessReports"
            }
        };
        const response = await api.post(REPORT_SERVICE_URL + 'businessrep/list/' + userId, requestData, headerConfig);
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_BUSINESS_REPORT_LIST",
            payload: response
        });
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const exportBusinessReports = (userId, requestData, callback) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getBusinessReports"
        }
    };
    try {
        await api.post(REPORT_SERVICE_URL + 'generate/businessrep/' + userId, requestData, headerConfig)
            .then(response => {
                dispatch(app.setLoading(false));
                dispatch({
                    type: "SET_CONSOLIDATED_REPORT",
                    payload: response
                });

                if (response.data.includes("successfully")) {
                    const modalObject = {
                        type: "confirm",
                        messageText: "We are currently working for building your Business Report.",
                        rounded: true,
                        acceptHandler: null,
                        rejectHandler: null,
                        hideConfirmationButtons: true,
                        iconToRender: "HOURGLASS_ICON",
                        consolidatedReport: true,
                        childComponentToRender: "You will receive an email notification once the report is ready to be downloaded."
                    }
                    dispatch(app.setAppModal(modalObject));
                    callback && callback();
                }
                else {
                    const modalObject = {
                        type: "confirm",
                        messageText: "No records found matching your criteria",
                        rounded: true,
                        acceptHandler: null,
                        rejectHandler: null,
                        hideConfirmationButtons: true,
                        iconToRender: "REJECT_RED_ICON",
                        consolidatedReport: true,
                        childComponentToRender: "Please modify your filter selection and try again."
                    }
                    dispatch(app.setAppModal(modalObject));
                }
            });
    } catch (error) {
        dispatch(app.setLoading(false));
        const modalObject = {
            type: "confirm",
            messageText: "No records found matching your criteria",
            rounded: true,
            acceptHandler: null,
            rejectHandler: null,
            hideConfirmationButtons: true,
            iconToRender: "REJECT_RED_ICON",
            consolidatedReport: true,
            childComponentToRender: "Please modify your filter selection and try again."
        }
        dispatch(app.setAppModal(modalObject));
    }
};

const downloadBusinessReport = (userId, reportId, reportTypeValue) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
   
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob"
    };

    await api.post(REPORT_SERVICE_URL + 'download/businessrep/' + userId + "/" + reportId + '?reportType=' + reportTypeValue, null, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), `BusinessReport_${reportId}.xlsx`);
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const businesReportActions = {
    getBusinessReports: getBusinessReports,
    exportBusinessReports: exportBusinessReports,
    downloadBusinessReport: downloadBusinessReport
}

export default businesReportActions;
